var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('SerailNoQrPrintComponent'),_c('loading',{attrs:{"active":_vm.isLoading,"color":"rgb(2, 110, 156)","loader":"bars"},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }